import { SchedulableInvoiceLine } from "@common/helpers/domains/accounting/invoiceScheduleLines";
import { isInvoiceItemLine } from "@common/helpers/lineItems";
import {
    InvoiceLineItemSchedule,
    InvoiceSchedule,
} from "@common/schemas/domains/invoice/invoice-response.schema";
import { getInvoiceScheduleAmount } from "@components/accounting/schedules/scheduleApplyInvoiceHelpers";

export interface InvoiceScheduleReplaceScope {
    amount: number;
    sourceLineIds?: string[];
}

interface ResolveInvoiceScheduleReplaceScopeParams {
    invoice: {
        total: number;
        schedule?: Pick<InvoiceSchedule, "scope">;
        lines?: Array<
            SchedulableInvoiceLine & { schedule?: InvoiceLineItemSchedule }
        >;
    };
    scheduleApplicationId: string | null;
}

export function resolveInvoiceScheduleReplaceScope({
    invoice,
    scheduleApplicationId,
}: ResolveInvoiceScheduleReplaceScopeParams): InvoiceScheduleReplaceScope {
    const wholeInvoiceScope = {
        amount: getInvoiceScheduleAmount({
            lines: invoice.lines,
            fallbackAmount: invoice.total,
        }),
    };
    if (invoice.schedule?.scope !== "lines" || scheduleApplicationId === null) {
        return wholeInvoiceScope;
    }
    const sourceLineIds = (invoice.lines ?? [])
        .filter(
            (line) =>
                isInvoiceItemLine(line) &&
                line.schedule?.scheduleApplicationId === scheduleApplicationId,
        )
        .map((line) => line.id);
    if (sourceLineIds.length === 0) {
        return wholeInvoiceScope;
    }
    return {
        sourceLineIds,
        amount: getInvoiceScheduleAmount({
            lines: invoice.lines,
            sourceLineIds,
            fallbackAmount: invoice.total,
        }),
    };
}
